import { AppBar, FormControl, Grid, InputLabel, Select, Tooltip, Typography } from '@material-ui/core';
import { useCallback, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { AssociatedPerson, DealDetail } from '@lib/deals';
import * as adapter from './replicate-form-adapter';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { thumbStack } from '@lib/common/css';
import { vestResolver } from '@hookform/resolvers/vest';
import { useFormSnackbarError, useRecentCallback } from '@lib/common';
import { CompanyEntity, C2PAddFormEntity } from '../types';
import { C2PPersonSelector, C2PCompanySelector } from '../c2p-features/c2p-add-entities';
import { purple } from '@material-ui/core/colors';
import { ControlledTextField } from 'pages/person-management/person-management-form/person-master-relation-form';
import { C2PValidationSuite } from '../add/validators';
import { FormActions } from '../add/form-actions';

type DealFormProps = {
  onSubmit: (deal: C2PAddFormEntity) => any;
  onDelete?: (deal: C2PAddFormEntity) => any;
  deal: any;
  createDeal?: boolean;
};

export function C2PReplicateForm({ deal, onSubmit, onDelete = null, createDeal = false }: DealFormProps) {
  const formDeal = useMemo(() => adapter.toForm(deal), [deal]);
  const form = useForm({
    defaultValues: formDeal,
    resolver: vestResolver(C2PValidationSuite),
    reValidateMode: 'onSubmit',
  });
  useEffect(() => {
    if (deal) {
      form.reset(adapter.toForm(deal));
    }
  }, [deal]);
  const watched = form.watch();

  useEffect(() => {}, [watched]);

  const onFinish = (values: any) => {
    const clean = {
      ...values,
      associated_person: (values.associated_person || []).filter(Boolean),
    };
    onSubmit(adapter.fromForm(clean));
  };
  const [showComments, setShowComments] = useState(false);

  const formError = useFormSnackbarError();
  const submitForm = form.handleSubmit(onFinish, formError);
  const formGrid = (
    <Grid container spacing={1}>
      <Grid item xs={12} style={{ marginBottom: "50px" }}>
        <C2PCompanySelector deal={formDeal} />
      </Grid>
      <br />
      <br />
      <Grid item xs={12}>
        <C2PPersonSelector deal={formDeal} />
      </Grid>
      <br />
      <br />
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Description
        </Typography>
        <ControlledTextField
          fullWidth
          variant="outlined"
          name={'description'}
          label={'Description'}
          control={form.control}
          defaultValue={''}
          multiline
          rows={5}
        />
      </Grid>
      <br/>
      <br/>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Sources
        </Typography>
        <ControlledTextField
          fullWidth
          variant="outlined"
          name={'sources'}
          label={'Sources Link'}
          control={form.control}
          defaultValue={''}
          multiline
          rows={3}
        />
      </Grid>
    </Grid>
  );


  const CompanyMappingAppBar = () => {
    return (
      <AppBar color="secondary" style={{ position: 'sticky', marginBottom: "40px", background: purple[800] }}>
        <Grid
          container
          justify="flex-end"
          alignItems="flex-end"
          spacing={2}
          style={{ margin: 0, width: '100%' }}>
          <Grid item>
            <FormActions
              submitForm={submitForm}
            />
          </Grid>
        </Grid>
      </AppBar>
    );
  };
if (!deal.company_name) return <div style={{width:'80%',height:"400px"}}>Loading...</div>;
  return (
    <FormProvider {...form}>
      <CompanyMappingAppBar />
      <form onSubmit={submitForm}>
        <input hidden name="id" ref={form.register} />
        <Grid style={{ position: 'relative' }} container spacing={3}>
          <Grid item xs={showComments ? 9 : 12}>
            {formGrid}
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
}


